var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.isError)?_c('Error'):_c('div',[(_vm.pageConfigReady && !_vm.isError)?_c('PageGenerator',{attrs:{"pageConfig":_vm.pageConfig,"env":_vm.env,"id":_vm.id,"userFrom":_vm.userFrom}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }